import React, { useState } from "react";
import { Link, Navigate, useSearchParams } from "react-router-dom";
import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase";
import { useAuth } from "../contexts/AuthContext";
import { BF, FF } from "../lib/constants";
import { PACKAGES, priceLabel } from "../lib/packages";

var inputStyle = { width: "100%", padding: "10px 12px", borderRadius: 8, border: "1px solid #ccc", fontSize: 15, outline: "none", marginBottom: 10, fontFamily: FF, boxSizing: "border-box", background: "#fff", minHeight: 44 };
var labelStyle = { fontFamily: BF, fontSize: 12, letterSpacing: 1, color: "#6B675F", margin: "6px 0 6px", fontWeight: 700, display: "block" };
var fnRegister = httpsCallable(functions, "registerClub");

// Aanmelden (build 2.4): als losse trainer of voor een hele club, met het gekozen
// pakket. Het account wordt meteen aangemaakt, maar krijgt pas toegang nadat de
// creator de aanmelding heeft goedgekeurd (en gefactureerd).
export default function Register() {
  var { user, loading, login } = useAuth();
  var [params] = useSearchParams();
  var startPkg = PACKAGES.some(function (p) { return p.key === params.get("pakket"); }) ? params.get("pakket") : "";
  var [type, setType] = useState(params.get("type") === "club" ? "club" : "trainer");
  var [f, setF] = useState({ firstName: "", lastName: "", email: "", clubName: "", place: "", password: "", password2: "", website: "", pakket: startPkg });
  var [err, setErr] = useState("");
  var [busy, setBusy] = useState(false);

  if (loading) return null;
  if (user) return <Navigate to="/" replace />;

  function set(k) { return function (e) { var n = Object.assign({}, f); n[k] = e.target.value; setF(n); }; }

  async function submit(e) {
    e.preventDefault();
    setErr("");
    if (f.password.length < 8) { setErr("Kies een wachtwoord van minimaal 8 tekens."); return; }
    if (f.password !== f.password2) { setErr("De twee wachtwoorden zijn niet hetzelfde."); return; }
    setBusy(true);
    try {
      await fnRegister({
        type: type, pakket: f.pakket, name: (f.firstName.trim() + " " + f.lastName.trim()).trim(), email: f.email,
        clubName: type === "club" ? f.clubName : "", place: f.place,
        password: f.password, website: f.website,
      });
      // Meteen inloggen; de app toont dan het "aanmelding ontvangen"-scherm.
      await login(f.email.trim().toLowerCase(), f.password);
    } catch (e2) {
      console.error(e2);
      var msg = e2 && e2.code && String(e2.code).indexOf("functions/") === 0 && e2.code !== "functions/internal" ? e2.message : "Aanmelden mislukt (" + ((e2 && (e2.code || e2.message)) || "onbekend") + ").";
      setErr(msg);
      setBusy(false);
    }
  }

  function seg(key, label) {
    var on = type === key;
    return (
      <button type="button" onClick={function () { setType(key); }} aria-pressed={on}
        style={{ flex: 1, minHeight: 40, borderRadius: 8, border: "none", background: on ? "#fff" : "transparent", boxShadow: on ? "0 1px 4px rgba(0,0,0,.12)" : "none", color: "#1C1B19", fontWeight: 700, fontSize: 14, cursor: "pointer", fontFamily: FF }}>
        {label}
      </button>
    );
  }

  return (
    <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: FF, background: "#F5F3EE", padding: 16 }}>
      <form onSubmit={submit} style={{ background: "#fff", borderRadius: 16, padding: 28, maxWidth: 420, width: "100%", boxShadow: "0 20px 60px rgba(0,0,0,.08)" }}>
        <h1 style={{ fontFamily: BF, fontSize: 24, color: "#1C1B19", marginBottom: 4, textAlign: "center", fontWeight: 800 }}>Aanmelden</h1>
        <p style={{ color: "#6B675F", fontSize: 14, marginBottom: 18, textAlign: "center", lineHeight: 1.5 }}>Na goedkeuring krijg je een mail en kun je inloggen.</p>

        <div style={{ display: "flex", gap: 4, padding: 4, borderRadius: 10, background: "#E7E3DA", marginBottom: 14 }}>
          {seg("trainer", "Ik ben trainer")}
          {seg("club", "Voor mijn club")}
        </div>

        <label style={labelStyle} htmlFor="rg-pkg">PAKKET</label>
        <select id="rg-pkg" value={f.pakket} onChange={set("pakket")} required style={inputStyle}>
          <option value="">Kies een pakket…</option>
          {PACKAGES.map(function (p) { return <option key={p.key} value={p.key}>{p.label} · {priceLabel(p.key)}</option>; })}
        </select>
        <p style={{ fontSize: 12, color: "#6B675F", margin: "-4px 0 10px" }}><Link to="/pakketten" style={{ color: "#6B675F" }}>Pakketten vergelijken</Link></p>

        {type === "club" && <>
          <span style={labelStyle}>JOUW CLUB</span>
          <input value={f.clubName} onChange={set("clubName")} placeholder="Naam van de club of tennisschool" required style={inputStyle} />
          <input value={f.place} onChange={set("place")} placeholder="Plaats (optioneel)" style={inputStyle} />
        </>}

        <span style={labelStyle}>JOUW ACCOUNT</span>
        <div style={{ display: "flex", gap: 8 }}>
          <input value={f.firstName} onChange={set("firstName")} placeholder="Voornaam" autoComplete="given-name" aria-label="Voornaam" required style={inputStyle} />
          <input value={f.lastName} onChange={set("lastName")} placeholder="Achternaam" autoComplete="family-name" aria-label="Achternaam" required style={inputStyle} />
        </div>
        <input type="email" value={f.email} onChange={set("email")} placeholder="E-mailadres" autoComplete="email" required style={inputStyle} />
        {type === "trainer" && <input value={f.place} onChange={set("place")} placeholder="Waar geef je les? (optioneel)" style={inputStyle} />}
        <input type="password" value={f.password} onChange={set("password")} placeholder="Wachtwoord (min. 8 tekens)" autoComplete="new-password" required style={inputStyle} />
        <input type="password" value={f.password2} onChange={set("password2")} placeholder="Wachtwoord herhalen" autoComplete="new-password" required style={inputStyle} />
        {/* Honeypot tegen bots: onzichtbaar voor mensen. */}
        <input value={f.website} onChange={set("website")} tabIndex={-1} autoComplete="off" aria-hidden="true" style={{ position: "absolute", left: -10000, width: 1, height: 1, opacity: 0 }} />

        {type === "club" && <p style={{ fontSize: 12, color: "#6B675F", lineHeight: 1.5, marginBottom: 10 }}>Jij wordt hoofdtrainer en kunt na goedkeuring zelf accounts voor je trainers aanmaken.</p>}
        {err && <p style={{ color: "#B83232", fontSize: 13, marginBottom: 8 }}>{err}</p>}
        <button type="submit" disabled={busy} style={{ width: "100%", minHeight: 46, borderRadius: 10, background: "#1A2744", color: "#fff", border: "none", cursor: busy ? "default" : "pointer", fontSize: 15, fontWeight: 700, opacity: busy ? .7 : 1 }}>{busy ? "Bezig..." : "Aanmelden"}</button>
        <div style={{ display: "flex", justifyContent: "space-between", marginTop: 14, fontSize: 13 }}>
          <Link to="/" style={{ color: "#6B675F" }}>← Startpagina</Link>
          <Link to="/login" style={{ color: "#6B675F" }}>Ik heb al een account</Link>
        </div>
      </form>
    </div>
  );
}
